var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.85355 6.14645c.19527.19526.19527.51184 0 .7071l-2 2c-.19526.19527-.51184.19527-.7071 0l-1-1c-.19527-.19526-.19527-.51184 0-.7071.19526-.19527.51184-.19527.7071 0l.64645.64644 1.64645-1.64644c.19526-.19527.51184-.19527.7071 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.85355 11.1464c.19527.1953.19527.5119 0 .7072l-2 2c-.19526.1952-.51184.1952-.7071 0l-1-1c-.19527-.1953-.19527-.5119 0-.7072.19526-.1952.51184-.1952.7071 0l.64645.6465 1.64645-1.6465c.19526-.1952.51184-.1952.7071 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 7.5c0-.27614.2239-.5.5-.5h3c.2761 0 .5.22386.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.22386-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 3c-1.38071 0-2.5 1.11929-2.5 2.5v9c0 1.3807 1.11929 2.5 2.5 2.5h4.09971c-.16194-.3168-.29407-.6514-.39268-1h-3.70703c-.82843 0-1.5-.6716-1.5-1.5v-9c0-.82843.67157-1.5 1.5-1.5h9c.8284 0 1.5.67157 1.5 1.5v3.70703c.3486.09861.6832.23074 1 .39268v-4.09971c0-1.38071-1.1193-2.5-2.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 19c2.4853 0 4.5-2.0147 4.5-4.5s-2.0147-4.5-4.5-4.5-4.5 2.0147-4.5 4.5 2.0147 4.5 4.5 4.5zm0-7c.2761 0 .5.2239.5.5v1.5h1.5c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-1.5v1.5c0 .2761-.2239.5-.5.5s-.5-.2239-.5-.5v-1.5h-1.5c-.2761 0-.5-.2239-.5-.5s.2239-.5.5-.5h1.5v-1.5c0-.2761.2239-.5.5-.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTaskIcon);
export default __webpack_public_path__ + "static/media/AddTaskIcon.304d9dcbcd694dd8467b0aaef4d4d521.svg";
export { ForwardRef as ReactComponent };